import React from 'react';
import { PackageIcon, TargetIcon, UsersIcon, BellIcon, DatabaseIcon, BarChart2Icon, ArrowUpRightIcon } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    icon: <PackageIcon size={28} data-id="element-455" />,
    title: 'Sponsorship Strategy & Packaging',
    description: 'Develop compelling sponsorship packages that maximize value for both sponsors and your event.',
    features: ['Market analysis & benchmarking', 'Value proposition development', 'Tiered package creation']
  }, {
    icon: <TargetIcon size={28} data-id="element-456" />,
    title: 'Targeted Prospecting & ABM',
    description: 'Identify and engage ideal sponsors through sophisticated targeting and account-based marketing.',
    features: ['Sponsor persona development', 'Predictive sponsor modeling', 'Multi-touch outreach campaigns']
  }, {
    icon: <UsersIcon size={28} data-id="element-457" />,
    title: 'Relationship-Driven Sales',
    description: 'Build meaningful connections with sponsors through consultative selling and relationship management.',
    features: ['Consultative sales approach', 'Negotiation & proposal management', 'Long-term relationship building']
  }, {
    icon: <BellIcon size={28} data-id="element-458" />,
    title: 'Multi-Channel Marketing',
    description: 'Engage potential sponsors through sophisticated, coordinated outreach across multiple channels.',
    features: ['LinkedIn & social selling', 'Email nurture sequences', 'Direct outreach & follow-up']
  }];
  return <section id="services" className="py-24 bg-white" data-id="element-459">
      <div className="container mx-auto px-6" data-id="element-460">
        <div className="mb-5" data-id="element-461">
          <span className="text-black font-medium inline-flex items-center gap-2 bg-[#f5f5f5] px-4 py-1.5 rounded-full shadow-sm" data-id="element-462">
            <div className="w-6 h-6 bg-[#FF7A39] rounded-sm" data-id="element-463"></div>
            Our services
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20 items-center" data-id="element-464">
          <div data-id="element-465">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6" data-id="element-466">
              Level up your sponsorship, improve{' '}
              <span className="font-serif italic text-[#FF7A39]" data-id="element-467">
                sales ROI
              </span>
            </h2>
            <p className="text-xl text-black/80 leading-relaxed" data-id="element-468">
              Better sponsorship leads to better marketing ROI. At Sales Source,
              we help you level up your complete sponsorship engine. From
              strategy to outreach, negotiation, and measurement.
            </p>
          </div>
          <div className="relative" data-id="element-469">
            <div className="absolute -top-6 -left-6 w-16 h-16 bg-[#FF7A39]/50 z-0 rounded-br-2xl" data-id="element-470"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sUs1gVj4HAdQnsEVx48Qu2/20230126_080712.jpg" alt="Conference venue setup" className="w-full h-auto object-cover rounded-lg shadow-md relative z-10" data-id="element-471" />
          </div>
        </div>
        {/* Main service with image */}
        <div className="bg-[#f5f5f5] rounded-lg overflow-hidden shadow-lg mb-16 border border-gray-100" data-id="element-472">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-473">
            <div className="h-full min-h-[300px] md:min-h-0" data-id="element-474">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Km97H1L7Y2skehVdXHy7m/Stroopwafel_stand.jpg" alt="Stroopwafel stand at conference" className="w-full h-full object-cover" data-id="element-475" />
            </div>
            <div className="p-10" data-id="element-476">
              <h3 className="text-2xl font-bold mb-5 text-black" data-id="element-477">
                Outsourced Sponsorship Sales
              </h3>
              <p className="text-black/70 mb-6 leading-relaxed" data-id="element-478">
                Our outsourced sponsorship sales service provides event
                organizers with a dedicated team of experts who handle the
                entire sponsorship acquisition process.
              </p>
              <p className="text-black/70 mb-8 leading-relaxed" data-id="element-479">
                We combine strategic insights, data-driven targeting, and
                relationship-building expertise to secure high-value sponsors
                aligned with your event's audience and objectives.
              </p>
              <a href="https://forms.gle/zspSVdBJ7eiHmqQj6" className="inline-flex items-center gap-2 bg-[#FF7A39] hover:bg-[#FF7A39]/90 text-black px-5 py-3 rounded-md transition-all w-fit shadow-md font-medium" data-id="element-480">
                Learn more <ArrowUpRightIcon size={18} data-id="element-481" />
              </a>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-482">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 duration-300" data-id="element-483">
              <div className="bg-[#FF7A39]/20 p-4 rounded-full w-fit mb-6" data-id="element-484">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-black" data-id="element-485">
                {service.title}
              </h3>
              <p className="text-black/70 mb-6 leading-relaxed" data-id="element-486">
                {service.description}
              </p>
              <ul className="space-y-3 text-black/70 mt-auto mb-6" data-id="element-487">
                {service.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-488">
                    <span className="text-[#FF7A39] mr-2 font-bold" data-id="element-489">•</span>
                    <span data-id="element-490">{feature}</span>
                  </li>)}
              </ul>
              <a href="#contact" className="inline-flex items-center gap-2 text-[#FF7A39] font-medium hover:text-[#FF7A39]/80 transition-colors mt-auto" data-id="element-491">
                Learn more <ArrowUpRightIcon size={18} data-id="element-492" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
};